import { CommonModule } from "@angular/common";
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { SharedModule } from "../shared/shared.module";
import { NavbarComponent } from "./components/navbar/navbar.component";
import { LoginComponent } from "./pages/login/login.component";
import { AuthModalComponent } from "./components/auth-modal/auth-modal.component";
import { LostPasswordComponent } from "./pages/lost-password/lost-password.component";
import { ModalResetPasswordTokenComponent } from "./components/modal-reset-password-token/modal-reset-password-token.component";

@NgModule({
  declarations: [
    LoginComponent,
    LostPasswordComponent,
    ModalResetPasswordTokenComponent,
    NavbarComponent,
  ],
  imports: [FormsModule, SharedModule, CommonModule, ReactiveFormsModule],
  entryComponents: [AuthModalComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class AuthModule {}
